import { render, staticRenderFns } from "./shapeType.vue?vue&type=template&id=23ad54fa&scoped=true"
import script from "./shapeType.vue?vue&type=script&lang=js"
export * from "./shapeType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ad54fa",
  null
  
)

export default component.exports